// @flow

export const PATH_MATCHERS = [
  { value: 'contains', label: 'Contains' },
  { value: 'doesNotContain', label: 'Does not contain' },
  { value: 'regex', label: 'Matches RegEx' }
]
